import { BasePageModel } from 'models/BasePageModel';
import { LoadingStatus } from 'models/LoadingStatus';

export default {
  meta: {
    title: '',
    tags: {},
    links: {},
    experiments: [],
    openGraphTags: {}
  },
  componentName: '_noComponent',
  pageName: '',
  status: LoadingStatus.Loading,
  webCatalog: '',
  breadCrumbs: [],
  breadCrumbsStructured: [],
  fullPageLoad: false,
  runningExperiments: {},
  menuAds: {},
  pageTopContentArea: { content: [] },
  frequentlyAskedQuestions: [],
  totalNumberOfFrequentlyAskedQuestions: 0
} as BasePageModel;
